import React, { Component } from "react";
import Input from "semantic-ui-react/dist/es/elements/Input";
import Modal from "../../../UIComponents/CustomModal/Modal";
import "./PostEmailModal.css";
import { getSparkInfo } from "../RawDataCard/postInfoUtils";
import { toast } from "react-toastify";
import Editor from "./Editor";

class PostEmailModal extends Component {
    constructor(props) {
        super(props);
        let username = JSON.parse(localStorage.getItem("company")).user_name;
        this.state = {
            subject: `${username} shared a post with you from Radarr.`,
            content: "",
            toAddress: "",
        };
        this.header = React.createRef();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.open === true && this.props.open === false) {
            this.setState({
                ...this.state,
                content: this.renderEmail(nextProps),
            });
        }
    }

    emailPost() {
        if (!this.validateEmails() || !this.validateSubject() || !this.validateContent()) return;
        let companyLogo = this.props.company.company_logo_v2;
        if (!companyLogo || !companyLogo.includes("https://")) companyLogo = this.props.company.company_logo;
        let addresses = this.state.toAddress?.map((val) => val.trim());
        this.props.emailPost(addresses, this.state.subject, this.state.content, companyLogo);
        let username = JSON.parse(localStorage.getItem("company")).user_name;
        this.setState({ toAddress: "", subject: `${username} shared a post with you from Radarr.` });
    }

    validateEmails() {
        let emails = this.state.toAddress;
        let re =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        emails = emails.map((email) => email.trim());
        let valid = emails.every((email) => re.test(email));
        if (!valid) toast.warn("Please Ensure The Emails Are Correct");
        return valid;
    }

    validateSubject() {
        let valid = this.state.subject.trim().length > 0;
        if (!valid) toast.warn("Please Ensure The Subject Is Not Empty");
        return valid;
    }

    validateContent() {
        let valid = this.state.content.trim().length > 0;
        if (!valid) toast.warn("Please Ensure The Content Is Not Empty");
        return valid;
    }

    handleSubjectChange(val) {
        this.setState({
            ...this.state,
            subject: val,
        });
    }

    handleToAddressChange(val) {
        const arr = val.split(",");
        this.setState({
            ...this.state,
            toAddress: arr,
        });
    }

    renderEmail(props) {
        let info = getSparkInfo(props.data);
        let postdataLink = info.link;
        if (info.isLexisNexisOffline) {
            postdataLink = "https://20twenty.radarr.com/unified/#/lnoffline?es-id=" + info._index.split("csdata-")[1] + ":" + info._id;
        }

        let postMailContent = info.content;
        let postImg = info.image;

        let noPostImage = null;
        let imgWid = null;
        let postImage = "";

        if (postImg) {
            noPostImage = "350";
            imgWid = "350px";
            postImage =
                '<span style="display: inline-block; margin-right: 10px; background-color: #ffffff;vertical-align: top;"><img src="' +
                postImg +
                '" style="width:100px; height:100px;"></span>';
        } else {
            noPostImage = "100%";
            imgWid = "600px";
        }

        let extraBreak = "<br><br>";

        let companyLogo = this.props.company.company_logo_v2;
        if (!companyLogo || !companyLogo.includes("https://")) companyLogo = this.props.company.company_logo;

        let postMail =
            // "<p>&nbsp;</p>" +
            // '<table width="600" cellspacing="0" cellpadding="0" outline="0" align="center" style="border-right: 1px solid #A7A9AC;border-left: 1px solid #A7A9AC;border-bottom: 1px solid #A7A9AC; outline: 0px !important">' +
            // "<tbody>" +
            // '<tr><td width="600" align="left" border="0" valign="bottom"  style="background-color: #424242; border-bottom: 7px solid #ffbb44; padding-left: 10px; padding-right: 20px; padding-bottom: 10px; padding-top:10px">' +
            // '<table  cellspacing="0" cellpadding="0" border="0" align="center">' +
            // "<tr>" +
            // '<td> <img style="max-height:70px;max-width:100px;" src="https://assets.radarr.com/uploads/radarr.png" /></td>' +
            // '<td width="400" border="0" align="left" valign="bottom"  style="text-align:center; background-color: #424242; ">' +
            // `<span align="left" float="left" style="text-decoration:none; font-family: Abel,Arial,Helvetica,sans-serif; font-size:18px; line-height: 1.4; color:#FFB644; -webkit-text-size-adjust: none; margin: 0px !important; padding: 15px 0px !important; display:inline-block;font-weight: 400 !important; text-rendering: optimizeLegibility;-webkit-font-smoothing: antialiased;">Post</span>` +
            // "</td>" +
            // '<td width="110" border="0" align="right" valign="bottom"  style="background-color: #424242; ">' +
            // '<a align="right" width="105"  float="right" target="_blank" href="http://appstage.radarr.com/" style=" text-decoration: none; outline:none; float: right; width: 105px; "><img width="105"  style="width:100%; float: right; border: 0px; outline: 0px; max-width: 105px; " src="' +
            // companyLogo +
            // '" alt="circus 2020"></a>' +
            // "</td></tr></table></td></tr>

            "<tr>" +
            '<td width="100%" border="0" align="left" valign="middle" style="background-color: #ffffff; vertical-align: middle; padding-left: 80px; padding-right: 70px; width: 600px; padding-top: 20px; padding-bottom: 10px;">' +
            postImage +
            '<span width="' +
            noPostImage +
            '" style="text-decoration:none; display:inline-block;font-family: Arial; font-family:Arial,Helvetica,sans-serif; font-size:12px; line-height: 1.4; color:#000000; -webkit-text-size-adjust: none; margin: 0px !important; max-width:' +
            imgWid +
            '; font-weight: 400; ">' +
            '<a href="' +
            postdataLink +
            '" style="text-decoration:none; font-weight: 400 !important; text-rendering: optimizeLegibility; -webkit-font-smoothing: antialiased; font-size:12px; line-height: 1.4;-webkit-text-size-adjust: none;">' +
            postMailContent +
            "</a><br/><br/>" +
            "</span>" +
            extraBreak +
            '<span width="457" style="text-decoration:none; display:inline-block;font-family: Arial; font-family:Arial,Helvetica,sans-serif; font-size:12px; line-height: 1.4; color:#000000; -webkit-text-size-adjust: none; margin: 0px !important; max-width: 457px; font-weight: 400; ">' +
            "Thanks for using Radarr!<br/>" +
            "The Radarr Team<br/>" +
            "</span>" +
            "</td></tr>";
        // <tr >" +
        // '<td width="600" border="0" height="3" align="center"  style="vertical-align:middle; background-color: #ffffff; padding-left:80px; padding-right: 80px;  vertical-align: bottom; text-align: center;">' +
        // '<img width="457" max-width="457" height="3" src="http://20twenty.circussocial.com/themes/basic/web/images/border.png" alt="circus2020" style=" border: 0px; outline: 0px; height: 3px;">' +
        // "</td></tr><tr >" +
        // '<td width="600" border="0" height="10" align="center"  style="vertical-align:middle; background-color: #ffffff; padding-left:80px; padding-right: 80px;  vertical-align: bottom; text-align: center;">' +
        // '<table  cellspacing="0" cellpadding="0" border="0" align="right">' +
        // // +'</td> </tr> <tr>'
        // "<tbody><tr>" +
        // '<td border="0" style="width: 20px; height: 20px; margin: 0px ; vertical-align:bottom; padding: 2px 0px 0px;"><a target="_blank" href="https://www.facebook.com/RadarrTechnologies" style=" text-decoration: none; outline:none; "><img width="15" height="15" src="http://20twenty.circussocial.com/themes/basic/web/images/fb-icon.png" alt="circus2020" style=" border: 0px; outline: 0px"></a></td>' +
        // '<td border="0" style="width: 20px; height: 20px; margin: 0px; vertical-align:bottom; padding:2px 0px 0px;"><a target="_blank" href="https://twitter.com/radarrtech" style=" text-decoration: none; outline:none;"><img width="15" height="15" src="http://20twenty.circussocial.com/themes/basic/web/images/twitter-icon.png" alt="circus2020" style=" border: 0px; outline: 0px"></a></td>' +
        // '<td border="0" style="width: 20px; height: 20px; margin: 0px; vertical-align:bottom; padding:2px 0px 0px;"><a target="_blank" href="https://www.linkedin.com/company/radarrtechnologies/" style=" text-decoration: none; outline:none;"><img width="15" height="15" src="http://20twenty.circussocial.com/themes/basic/web/images/linkedIn.png" alt="circus2020" style=" border: 0px; outline: 0px"></a></td>' +
        // '<td border="0" style=" height: 24px; margin: 0px; vertical-align:middle; padding:2px 0px 0px; "><span  style=" text-decoration: none; outline:none; font-family: Arial,Helvetica,sans-serif; font-size:8px; line-height: 1.4; color:#808285; -webkit-text-size-adjust: none; margin: 0px !important;">Copyright&nbsp;&copy;&nbsp;2021 Radarr</span></td>' +
        // "</tr></tbody></table></td></tr><tr>" +
        // '<td border="0" width="600" height="83" align="left" valign="middle" style="background-color: #ffffff; vertical-align: middle; padding-left: 80px; padding-right: 80px;">' +
        // '<span style="text-decoration:none; font-family: Arial,Helvetica,sans-serif; font-size:9px; line-height: 1.4; color:#808285; -webkit-text-size-adjust: none; margin: 0px !important; padding: 20px 0px 10px !important; font-weight:bold; display: block; font-weight: 400 !important; text-rendering: optimizeLegibility;-webkit-font-smoothing: antialiased;">© 2021 Radarr.the Radarr logo are registered trademarks of Radarr. All rights reserved.<br/> <br/>' +
        // "Radarr Business Address:<br/>" +
        // "Singapore - Level 28, The Gateway East, 152 Beach Road, Singapore - 189721<br/>" +
        // "Bangalore - 419-F, Davanam Golden Square Prime, 4th Floor Davanam Sarovar Portico, Koramangala, India – 560068<br/>" +
        // "</span>" +
        // "</td></tr></tbody></table>" +
        // '<div style="display:none; white-space:nowrap; font:15px courier; color:#ffffff;"> - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - </div>' +
        // "<p>&nbsp;</p>";
        return postMail;
    }

    onChange = (e) => {
        this.setState({
            ...this.state,
            content: e.editor.getData(),
        });
    };

    render() {
        return (
            <Modal className={`post-email-modal`} show={this.props.open} onClose={() => this.props.hideModal()}>
                <Modal.Header>Email Post</Modal.Header>
                <Modal.Content>
                    <div className="email-to">
                        <label> To </label>
                        <Input
                            placeholder="Add mulitple email addresses with comma"
                            value={this.state.toAddress}
                            onChange={(e, d) => this.handleToAddressChange(d.value)}
                        />
                    </div>
                    <div className="email-subject">
                        <label> Subject </label>
                        <Input value={this.state.subject} onChange={(e, d) => this.handleSubjectChange(d.value)} placeholder="Subject" />
                    </div>

                    <Editor content={this.state.content} onChange={this.onChange} />
                </Modal.Content>
                <Modal.Actions>
                    <Modal.ActionButton normal onClick={() => this.props.hideModal()}>
                        Cancel
                    </Modal.ActionButton>
                    <Modal.ActionButton filled onClick={() => this.emailPost()}>
                        Send
                    </Modal.ActionButton>
                </Modal.Actions>
            </Modal>
        );
    }
}

export default PostEmailModal;
